<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Input

  CodeSample(name="Default" :pug="defaultPug" :html="defaultHtml" )
    input.input(placeholder='Text input', type='text')

  CodeSample(name="Sizes" :pug="sizesPug" :html="sizesHtml" class="u-mt-md")
    input.input.is-tiny(placeholder='is-tiny', type='text')
    input.input.is-small(placeholder='is-small', type='text')
    input.input.is-normal(placeholder='is-normal', type='text')
    input.input.is-large(placeholder='is-large', type='text')
    input.input.is-massive(placeholder='is-massive', type='text')

  CodeSample(name="Colors" :pug="colorsPug" :html="colorsHtml" class="u-mt-md")
    input.input.is-primary(placeholder='is-primary', type='text')
    input.input.is-secondary(placeholder='is-secondary', type='text')
    input.input.is-info(placeholder='is-info', type='text')
    input.input.is-success(placeholder='is-success', type='text')
    input.input.is-warning(placeholder='is-warning', type='text')
    input.input.is-danger(placeholder='is-danger', type='text')
    input.input.is-black(placeholder='is-black', type='text')
    input.input.is-white(placeholder='is-white', type='text')

  CodeSample(name="Rounded" :pug="roundedPug" :html="roundedHtml" class="u-mt-md")
    input.input.is-primary.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-secondary.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-info.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-success.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-warning.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-danger.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-black.is-rounded(placeholder='is-rounded', type='text')
    input.input.is-white.is-rounded(placeholder='is-rounded', type='text')


  CodeSample(name="Error" :pug="colorsPug" :html="colorsHtml" class="u-mt-md")
    input.input.has-error.is-primary(placeholder='is-primary', type='text')
    span.input-message.is-primary.is-tiny is-primary
    input.input.has-error.is-secondary(placeholder='is-secondary', type='text')
    span.input-message.is-secondary.is-small is-secondary
    input.input.has-error.is-info(placeholder='is-info', type='text')
    span.input-message.is-info.is-normal is-info
    input.input.has-error.is-success(placeholder='is-success', type='text')
    span.input-message.is-success.is-large is-success
    input.input.has-error.is-warning(placeholder='is-warning', type='text')
    span.input-message.is-warning.is-massive is-warning
    input.input.has-error.is-danger(placeholder='is-danger', type='text')
    span.input-message.is-danger is-danger
    input.input.has-error.is-black(placeholder='is-black', type='text')
    span.input-message.is-black is-black
    input.input.has-error.is-white(placeholder='is-white', type='text')
    span.input-message.is-white is-white












  CodeSample(name="Disabled" :pug="disabledPug" :html="disabledHtml" class="u-mt-md")
    input.input.is-disabled(value='is-disabled', type='text', disabled)


  table.table.is-relaxed.u-mt-md
    thead
      tr
        th Modifier
        th Description
        th Class
    tbody
      tr
        td Color
        td indicates the element state
        td
          p .is-black
          p .is-white
          p .is-primary
          p .is-secondary
          p .is-info
          p .is-success
          p .is-warning
          p .is-danger
      tr
        td Size
        td changes the element size based on font-size
        td
          p .is-tiny
          p .is-small
          p .is-normal
          p .is-large
          p .is-massive
      tr
        td Rounded
        td add rounded corners to a input
        td .is-rounded
      tr
        td Disabled
        td indicates that the input is disabled
        td .is-disabled


</template>

<script>
import CodeSample from '~/components/CodeSample';

export default {
  scrollToTop: true,
  layout: 'base',
  head: () => ({
    title: 'Input'
  }),
  components: {
    CodeSample
  },
  data: () => ({
    defaultPug: 'input.input(placeholder="Text input", type="text")',
    defaultHtml: '<input placeholder="Text input" type="text" class="input"/>',
    sizesPug: `input.input.is-tiny(placeholder='is-tiny', type='text')
input.input.is-small(placeholder='is-small', type='text')
input.input.is-normal(placeholder='is-normal', type='text')
input.input.is-large(placeholder='is-large', type='text')
input.input.is-massive(placeholder='is-massive', type='text')`,
    sizesHtml: `<input placeholder="is-tiny" type="text" class="input is-tiny"/>
<input placeholder="is-small" type="text" class="input is-small"/>
<input placeholder="is-normal" type="text" class="input is-normal"/>
<input placeholder="is-large" type="text" class="input is-large"/>
<input placeholder="is-massive" type="text" class="input is-massive"/>`,
    colorsPug: `input.input.is-primary(placeholder='is-primary', type='text')
input.input.is-secondary(placeholder='is-secondary', type='text')
input.input.is-info(placeholder='is-info', type='text')
input.input.is-success(placeholder='is-success', type='text')
input.input.is-warning(placeholder='is-warning', type='text')
input.input.is-danger(placeholder='is-danger', type='text')
input.input.is-black(placeholder='is-black', type='text')
input.input.is-white(placeholder='is-white', type='text')`,
    colorsHtml: `<input placeholder="is-primary" type="text" class="input is-primary"/>
<input placeholder="is-secondary" type="text" class="input is-secondary"/>
<input placeholder="is-info" type="text" class="input is-info"/>
<input placeholder="is-success" type="text" class="input is-success"/>
<input placeholder="is-warning" type="text" class="input is-warning"/>
<input placeholder="is-danger" type="text" class="input is-danger"/>
<input placeholder="is-black" type="text" class="input is-black"/>
<input placeholder="is-white" type="text" class="input is-white"/>`,
    roundedPug: `input.input.is-primary.is-rounded(placeholder='is-rounded', type='text')
input.input.is-secondary.is-rounded(placeholder='is-rounded', type='text')
input.input.is-info.is-rounded(placeholder='is-rounded', type='text')
input.input.is-success.is-rounded(placeholder='is-rounded', type='text')
input.input.is-warning.is-rounded(placeholder='is-rounded', type='text')
input.input.is-danger.is-rounded(placeholder='is-rounded', type='text')
input.input.is-black.is-rounded(placeholder='is-rounded', type='text')
input.input.is-white.is-rounded(placeholder='is-rounded', type='text')`,
    roundedHtml: `<input placeholder="is-rounded" type="text" class="input is-primary is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-secondary is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-info is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-success is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-warning is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-danger is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-black is-rounded"/>
<input placeholder="is-rounded" type="text" class="input is-white is-rounded"/>`,
    disabledPug: 'input.input.is-disabled(value="is-disabled", type="text", disabled)',
    disabledHtml: '<input value="is-disabled" type="text" disabled="disabled" class="input is-disabled"/>'
  })
};
</script>
